/**
 * 正则表达式验证工具对象
 * @namespace
 * @property {RegExp} naturalNumber - 验证自然数（包括0和正整数）
 * @property {RegExp} english - 验证纯英文字符
 * @property {RegExp} noChineseCharacter - 验证不包含中文字符
 * @property {RegExp} telephone - 验证座机号码（格式：XXX-XXXXXXX 或 XXXX-XXXXXXX）
 * @property {RegExp} bankCard - 验证银行卡号（10-20位数字）
 * @property {RegExp} IDNumber - 验证证件号码（50位以内的字母和数字）
 * @property {RegExp} IDCard - 验证身份证号码（18位，支持尾号为X）
 * @property {RegExp} qq - 验证QQ号码（5-12位数字）
 * @property {RegExp} url - 验证网址（仅支持http/https协议）
 * @property {RegExp} enNum0to20 - 验证0-20位的英文和数字
 * @property {RegExp} cnEnSpace2to100 - 验证2-100位的中英文和空格
 * @property {RegExp} numLinefeed - 验证数字和换行符
 * @property {RegExp} char0to255 - 验证255位以内的任意字符
 * @property {RegExp} moneyNumber - 验证金额（正数，最多两位小数）
 * @property {RegExp} moneyNumberF - 验证金额（支持正负数，最多两位小数）
 * @property {RegExp} phone - 验证手机号（支持国内主流号段）
 * @property {RegExp} integerNumber - 验证正整数（可带+号）
 * @property {RegExp} email - 验证电子邮箱地址
 *
 * @example
 * // 验证手机号
 * validate.phone.test('13812345678') // true
 *
 * // 验证金额
 * validate.moneyNumber.test('123.45') // true
 */
export const validate = {
  // 验证自然数
  naturalNumber: /^(([0-9]*[1-9][0-9]*)|(0+))$/,
  // 英文
  english: /^.[A-Za-z]+$/,
  // 禁止输入汉字
  noChineseCharacter: /^[^\u4e00-\u9fa5]+$/,
  // 座机
  // telephone: /^\d{3}-\d{7,8}|\d{4}-\d{7,8}$/,
  telephone: /^(0\d{2}-\d{8}|0\d{3}-\d{7}|\d{7,8})$/,
  // 座机（支持大陆和港澳台）
  // telephone: /^((\d{3,4}-)?[0-9]{7,8}|(\(\d{2,4}\)|\d{2,4}-)?[0-9]{7,8}|852[0-9]{8}|853[0-9]{7})$/,
  // 银行卡号码
  bankCard: /^[1-9]\d{9,19}$/,
  // 证件号码
  IDNumber: /^[a-z0-9A-Z]{0,50}$/,
  // 身份证号码,包括15位和18位的
  IDCard: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{7}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/,
  // QQ号码
  qq: /^[1-9]\d{4,11}$/,
  // 网址, 仅支持http和https开头的
  url: /^(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?$/,
  // 0到20位的英文字符和数字
  enNum0to20: /^[a-z0-9A-Z]{0,20}$/,
  // 2到100位的中英文字符和空格
  cnEnSpace2to100: /^[a-zA-Z\u4E00-\u9FA5\s*]{2,100}$/,
  // 数字和换行符
  numLinefeed: /^[0-9\n*]+$/,
  // 255位以内的字符
  char0to255: /^.{0,255}$/,
  // 金额数字
  moneyNumber: /^\d+(\.\d{1,2})?$/,
  // 金额数字,可为负数
  moneyNumberF: /^(\+|-?)\d+(\.\d{1,2})?$/,
  // 手机号校验 11位数字
  // phone: /^1(30|31|32|33|34|35|36|37|38|39|40|45|46|47|49|50|51|52|53|55|56|57|58|59|62|65|66|67|70|71|72|73|75|76|77|78|80|81|82|83|84|85|86|87|88|89|91|93|95|96|97|98|99)\d{8}$/,
  phone: /^1(3[0-9]|4[0,5-6,9]|5[0-3,5-9]|6[2,5-7]|7[0-3,5-8]|8[0-9]|9[1,3,5-9])\d{8}$/,
  // 手机号校验（支持大陆和港澳台）
  // phone: /^(1(30|31|32|33|34|35|36|37|38|39|40|45|46|47|49|50|51|52|53|55|56|57|58|59|62|65|66|67|70|71|72|73|75|76|77|78|80|81|82|83|84|85|86|87|88|89|91|93|95|96|97|98|99)\d{8}|852[5-9]\d{7}|853[6-9]\d{7}|886[0-9]\d{7})$/,
  // 正整数
  integerNumber: /^[+]{0,1}(\d+)$/,
  // Email
  email: /^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/,
  // 手机和座机
  // telephoneAndPhone: /^(((\d{3,4}-)?[0-9]{7,8})|(1(3|4|5|6|7|8|9)\d{9}))$/,
  telephoneAndPhone: /^(1(3[0-9]|4[0,5-6,9]|5[0-3,5-9]|6[2,5-7]|7[0-3,5-8]|8[0-9]|9[1,3,5-9])\d{8}|0\d{2}-\d{8}|0\d{3}-\d{7}|\d{7,8})$/,
  // 手机和座机（支持大陆和港澳台）
  // telephoneAndPhone: /^(((\d{3,4}-)?[0-9]{7,8}|(\(\d{2,4}\)|\d{2,4}-)?[0-9]{7,8}|852[0-9]{8}|853[0-9]{7})|(1(3|4|5|6|7|8|9)\d{9})|((852|853|886)\d{8}))$/,

}
